// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColumnFilter-module__font-s-10___SOvsY {
  font-size: 10px !important;
}

.ColumnFilter-module__font-s-12___qwx4V {
  font-size: 12px !important;
}

.ColumnFilter-module__font-s-13___DGAtr {
  font-size: 13px !important;
}

.ColumnFilter-module__font-s-14___wES5H {
  font-size: 14px !important;
}

.ColumnFilter-module__font-s-15___uVz8k {
  font-size: 15px !important;
}

.ColumnFilter-module__font-s-16___RWRye {
  font-size: 16px !important;
}

.ColumnFilter-module__font-s-18___Wk1j1 {
  font-size: 18px !important;
}

.ColumnFilter-module__font-s-20___RGdiC {
  font-size: 20px !important;
}

.ColumnFilter-module__font-s-22___zBSMn {
  font-size: 22px !important;
}

.ColumnFilter-module__font-s-28___RmTcp {
  font-size: 28px !important;
}

.ColumnFilter-module__font-w-400___y1BaY {
  font-weight: 400 !important;
}

.ColumnFilter-module__font-w-500___FCy3E {
  font-weight: 500 !important;
}

.ColumnFilter-module__font-w-600___z7_0M {
  font-weight: 600 !important;
}

.ColumnFilter-module__font-w-700___VK_lB {
  font-weight: 700 !important;
}

.ColumnFilter-module__p-5___KCh2E {
  padding: 5px !important;
}

.ColumnFilter-module__p-12___qifYn {
  padding: 12px !important;
}

.ColumnFilter-module__p-16___gWmeZ {
  padding: 16px !important;
}

.ColumnFilter-module__p-30___n2ymq {
  padding: 30px !important;
}

.ColumnFilter-module__p-b-0___tOteC {
  padding-bottom: 0 !important;
}

.ColumnFilter-module__p-b-5___drytx {
  padding-bottom: 5px !important;
}

.ColumnFilter-module__p-b-10___DH3SL {
  padding-bottom: 10px !important;
}

.ColumnFilter-module__p-b-12___RvZyd {
  padding-bottom: 12px !important;
}

.ColumnFilter-module__p-b-16___EtglN {
  padding-bottom: 16px !important;
}

.ColumnFilter-module__p-b-18___Pbcfv {
  padding-bottom: 18px !important;
}

.ColumnFilter-module__p-b-20___EoymV {
  padding-bottom: 20px !important;
}

.ColumnFilter-module__p-b-25___L8yWL {
  padding-bottom: 25px !important;
}

.ColumnFilter-module__p-b-30___MEF4a {
  padding-bottom: 30px !important;
}

.ColumnFilter-module__p-b-50___E5OWQ {
  padding-bottom: 50px !important;
}

.ColumnFilter-module__p-t-0___ymM7X {
  padding-top: 0 !important;
}

.ColumnFilter-module__p-t-12___DnkhM {
  padding-top: 12px !important;
}

.ColumnFilter-module__p-t-16___K3fvz {
  padding-top: 16px !important;
}

.ColumnFilter-module__p-t-18___q5coz {
  padding-top: 18px !important;
}

.ColumnFilter-module__p-t-20___TDxFP {
  padding-top: 20px !important;
}

.ColumnFilter-module__p-t-30___wrZJ3 {
  padding-top: 30px !important;
}

.ColumnFilter-module__p-t-40___cfPVu {
  padding-top: 40px !important;
}

.ColumnFilter-module__p-t-50___CHIBv {
  padding-top: 50px !important;
}

.ColumnFilter-module__p-l-20___vOxQY {
  padding-left: 20px !important;
}

.ColumnFilter-module__p-l-30___atwTp {
  padding-left: 30px !important;
}

.ColumnFilter-module__p-l-40___HTb1J {
  padding-left: 40px !important;
}

.ColumnFilter-module__p-r-16___ncZ9f {
  padding-right: 16px !important;
}

.ColumnFilter-module__p-r-20___ZyWr5 {
  padding-right: 20px !important;
}

.ColumnFilter-module__p-r-30___jICHk {
  padding-right: 30px !important;
}

.ColumnFilter-module__p-r-50___MsQop {
  padding-right: 50px !important;
}

.ColumnFilter-module__p-r-60___G5OKt {
  padding-right: 60px !important;
}

.ColumnFilter-module__m-b-1___gQ1pT {
  margin-bottom: 1px !important;
}

.ColumnFilter-module__m-b-2___bl41J {
  margin-bottom: 2px !important;
}

.ColumnFilter-module__m-b-6___cEY6d {
  margin-bottom: 6px !important;
}

.ColumnFilter-module__m-b-8___qln0H {
  margin-bottom: 8px !important;
}

.ColumnFilter-module__m-b-10____2XF_ {
  margin-bottom: 10px !important;
}

.ColumnFilter-module__m-b-14___FXaIK {
  margin-bottom: 14px !important;
}

.ColumnFilter-module__m-b-16___Pess4 {
  margin-bottom: 16px !important;
}

.ColumnFilter-module__m-b-20___czgKc {
  margin-bottom: 20px !important;
}

.ColumnFilter-module__m-b-22___gIPyn {
  margin-bottom: 22px !important;
}

.ColumnFilter-module__m-b-24___sjvSd {
  margin-bottom: 24px !important;
}

.ColumnFilter-module__m-b-30___I2io6 {
  margin-bottom: 30px !important;
}

.ColumnFilter-module__m-b-32___XCd2n {
  margin-bottom: 32px !important;
}

.ColumnFilter-module__m-b-40___b3LLT {
  margin-bottom: 40px !important;
}

.ColumnFilter-module__m-t-2___p9c0d {
  margin-top: 2px !important;
}

.ColumnFilter-module__m-t-3___IlNKS {
  margin-top: 3px !important;
}

.ColumnFilter-module__m-t-4___VtP88 {
  margin-top: 4px !important;
}

.ColumnFilter-module__m-t-5___D60Ib {
  margin-top: 5px !important;
}

.ColumnFilter-module__m-t-8___cfgK4 {
  margin-top: 8px !important;
}

.ColumnFilter-module__m-t-10___opGnq {
  margin-top: 10px !important;
}

.ColumnFilter-module__m-t-15___nqK0C {
  margin-top: 15px !important;
}

.ColumnFilter-module__m-t-16___x_gqo {
  margin-top: 16px !important;
}

.ColumnFilter-module__m-t-20___nNqz_ {
  margin-top: 20px !important;
}

.ColumnFilter-module__m-t-22___kf22G {
  margin-top: 22px !important;
}

.ColumnFilter-module__m-t-30___ZfoKt {
  margin-top: 30px !important;
}

.ColumnFilter-module__m-t-32___JLMmB {
  margin-top: 32px !important;
}

.ColumnFilter-module__m-l-auto___NZNO5 {
  margin-left: auto !important;
}

.ColumnFilter-module__m-l-4___yLbpn {
  margin-left: 4px !important;
}

.ColumnFilter-module__m-l-5___Emu_r {
  margin-left: 5px !important;
}

.ColumnFilter-module__m-l-6___dq2TD {
  margin-left: 6px !important;
}

.ColumnFilter-module__m-l-8___N3eqS {
  margin-left: 8px !important;
}

.ColumnFilter-module__m-l-10___c0_1h {
  margin-left: 10px !important;
}

.ColumnFilter-module__m-l-16___YTINc {
  margin-left: 16px !important;
}

.ColumnFilter-module__m-l-20___c9tLv {
  margin-left: 20px !important;
}

.ColumnFilter-module__m-l-24___tLQuG {
  margin-left: 24px !important;
}

.ColumnFilter-module__m-l-30___kUDpn {
  margin-left: 30px !important;
}

.ColumnFilter-module__m-l-35___YPGAV {
  margin-left: 35px !important;
}

.ColumnFilter-module__m-l-40___vdCy4 {
  margin-left: 40px !important;
}

.ColumnFilter-module__m-r-8___b8yly {
  margin-right: 8px !important;
}

.ColumnFilter-module__m-r-10___RPoU9 {
  margin-right: 10px !important;
}

.ColumnFilter-module__m-r-16___sYSWi {
  margin-right: 16px !important;
}

.ColumnFilter-module__m-r-20___PpcWn {
  margin-right: 20px !important;
}

.ColumnFilter-module__m-r-24___H38ae {
  margin-right: 24px !important;
}

.ColumnFilter-module__m-r-30___w60lq {
  margin-right: 30px !important;
}

.ColumnFilter-module__m-r-40___DLSch {
  margin-right: 40px !important;
}

.ColumnFilter-module__border-r-3___sMeHE {
  border-radius: 3px !important;
}

.ColumnFilter-module__border-r-4___OiuCo {
  border-radius: 4px !important;
}

.ColumnFilter-module__border-r-6___H4CYO {
  border-radius: 6px !important;
}

.ColumnFilter-module__border-r-10___qYwMG {
  border-radius: 10px !important;
}

.ColumnFilter-module__border-r-12___YxjpI {
  border-radius: 12px !important;
}

.ColumnFilter-module__border-r-16___Hy2P9 {
  border-radius: 16px !important;
}

.ColumnFilter-module__border-r-50___LF0Z8 {
  border-radius: 50% !important;
}

.ColumnFilter-module__primary-border___CNzil {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ColumnFilter-module__primary-border-b___VyK3x {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ColumnFilter-module__primary-border-t___Sn2br {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ColumnFilter-module__primary-border-l___vZyi4 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ColumnFilter-module__primary-border-r___TJdMb {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ColumnFilter-module__secondary-border___zJCYd {
  border: 1px solid #637768;
}

.ColumnFilter-module__secondary-border-b___eb7Ro {
  border-bottom: 1px solid #637768;
}

.ColumnFilter-module__secondary-border-t___LZsSS {
  border-top: 1px solid #637768;
}

.ColumnFilter-module__secondary-border-l____fYtM {
  border-left: 1px solid #637768;
}

.ColumnFilter-module__secondary-border-r___JNPBl {
  border-right: 1px solid #637768;
}

.ColumnFilter-module__gap-0___Fbkc9 {
  gap: 0 !important;
}

.ColumnFilter-module__gap-2___rz0Vm {
  gap: 2px !important;
}

.ColumnFilter-module__gap-4___p5ZBw {
  gap: 4px !important;
}

.ColumnFilter-module__gap-5___eYi3N {
  gap: 5px !important;
}

.ColumnFilter-module__gap-6___cCI0l {
  gap: 6px !important;
}

.ColumnFilter-module__gap-8___fkHb9 {
  gap: 8px !important;
}

.ColumnFilter-module__gap-10___PGIps {
  gap: 10px !important;
}

.ColumnFilter-module__gap-12___AV13S {
  gap: 12px !important;
}

.ColumnFilter-module__gap-14___t6rQs {
  gap: 14px !important;
}

.ColumnFilter-module__gap-16___nms6y {
  gap: 16px !important;
}

.ColumnFilter-module__gap-18___OFpfv {
  gap: 18px !important;
}

.ColumnFilter-module__gap-20___qVkdy {
  gap: 20px !important;
}

.ColumnFilter-module__gap-24___gluA4 {
  gap: 24px !important;
}

.ColumnFilter-module__gap-26___N3hYZ {
  gap: 26px !important;
}

.ColumnFilter-module__gap-30___vwt0e {
  gap: 30px !important;
}

.ColumnFilter-module__gap-32____Wp5Y {
  gap: 32px !important;
}

.ColumnFilter-module__gap-40___LK9Ia {
  gap: 40px !important;
}

.ColumnFilter-module__gap-50___JfbvT {
  gap: 50px !important;
}

.ColumnFilter-module__flex-1____pRZ_ {
  flex: 1;
}

.ColumnFilter-module__flex-none___Pb2Qm {
  flex: none !important;
}

.ColumnFilter-module__flex-column___Q0gTu {
  display: flex;
  flex-direction: column !important;
}

.ColumnFilter-module__flex-row___alh8f {
  display: flex;
  flex-direction: row !important;
}

.ColumnFilter-module__vertically-centered___UB4_L {
  display: flex;
  align-items: center !important;
}

.ColumnFilter-module__horizontally-centered___HgQaF {
  display: flex;
  justify-content: center !important;
}

.ColumnFilter-module__horizontally-end___r4WB1 {
  display: flex;
  justify-content: end !important;
}

.ColumnFilter-module__vertically-start___lx6ko {
  display: flex;
  align-items: start !important;
}

.ColumnFilter-module__space-between___n5K9v {
  display: flex;
  justify-content: space-between !important;
}

.ColumnFilter-module__flex-wrap___X5Nt_ {
  flex-wrap: wrap !important;
}

.ColumnFilter-module__height-100___Alhip {
  height: 100%;
}

.ColumnFilter-module__width-50___CZcW8 {
  width: 50% !important;
}

.ColumnFilter-module__width-100___WrOFO {
  width: 100%;
}

.ColumnFilter-module__cursor-pointer___tHrqd {
  cursor: pointer;
}

.ColumnFilter-module__cursor-not-allowed___Vv0NT {
  cursor: not-allowed !important;
}

.ColumnFilter-module__absolute-centered___qYO9n {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ColumnFilter-module__absolute___Ko8X0 {
  position: absolute;
}

.ColumnFilter-module__relative___n3Lqf {
  position: relative;
}

.ColumnFilter-module__fixed___dlTuQ {
  position: fixed;
}

.ColumnFilter-module__visible___aoqle {
  opacity: 1;
}

.ColumnFilter-module__invisible___vXi3P {
  opacity: 0;
}

.ColumnFilter-module__col-90___YSTq1 {
  width: 90% !important;
}

.ColumnFilter-module__col-auto___wRbeX {
  width: auto !important;
}

.ColumnFilter-module__medical-tabs___gCtzh {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ColumnFilter-module__medical-table-new___Ayx3R {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ColumnFilter-module__medical-table-new___Ayx3R:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ColumnFilter-module__medical-table-new___Ayx3R::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ColumnFilter-module__medical-table-new___Ayx3R::-webkit-scrollbar-track {
  display: none;
}
.ColumnFilter-module__medical-table-new___Ayx3R.ColumnFilter-module__no-pagination___bpo4x {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ColumnFilter-module__medical-table-new___Ayx3R.ColumnFilter-module__no-pagination___bpo4x:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ColumnFilter-module__medical-table-new___Ayx3R.ColumnFilter-module__no-pagination___bpo4x::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ColumnFilter-module__medical-table-new___Ayx3R.ColumnFilter-module__no-pagination___bpo4x::-webkit-scrollbar-track {
  display: none;
}

.ColumnFilter-module__medical-table-empty___sCwuY {
  padding: 14px 40px !important;
}

.ColumnFilter-module__icon-btn___IdsZN {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ColumnFilter-module__search-icon___UuSAe {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ColumnFilter-module__disable-select___D2nHj {
  user-select: none;
}

.ColumnFilter-module__break-word___d1it7 {
  word-break: break-word;
}

.ColumnFilter-module__popup-clear-btn___F7ko_ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ColumnFilter-module__scroll-m-b-20___bob4l {
  scroll-margin-bottom: 20px;
}

.ColumnFilter-module__container___tMxR4 {
  display: flex;
}
.ColumnFilter-module__container___tMxR4 .ColumnFilter-module__type___Ci9Ub {
  display: flex;
  position: relative;
}
.ColumnFilter-module__container___tMxR4 .ColumnFilter-module__type___Ci9Ub .ColumnFilter-module__filter___w0wu1 > button {
  padding: 0;
}
.ColumnFilter-module__container___tMxR4 .ColumnFilter-module__type___Ci9Ub .ColumnFilter-module__badge___TG5wl {
  top: -11px;
  right: -19px;
  position: absolute;
}

.ColumnFilter-module__option___dCkg6 {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #365844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/ColumnFilter/ColumnFilter.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,kBAAA;AA8pBJ;AA3pBM;EACE,UAAA;AA6pBR;AAzpBI;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AA2pBN;;AAtpBA;EEGE,+BApBO;EAqBP,gBAFmD;EFAnD,iBAAA;EACA,cAAA;AA0pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n\n  .type {\n    display: flex;\n    position: relative;\n\n    .filter {\n      & > button {\n        padding: 0;\n      }\n    }\n\n    .badge {\n      top: -11px;\n      right: -19px;\n      position: absolute;\n    }\n  }\n}\n\n.option {\n  @include get-font($roboto);\n  line-height: 15px;\n  color: #365844;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ColumnFilter-module__font-s-10___SOvsY`,
	"fontS12": `ColumnFilter-module__font-s-12___qwx4V`,
	"fontS13": `ColumnFilter-module__font-s-13___DGAtr`,
	"fontS14": `ColumnFilter-module__font-s-14___wES5H`,
	"fontS15": `ColumnFilter-module__font-s-15___uVz8k`,
	"fontS16": `ColumnFilter-module__font-s-16___RWRye`,
	"fontS18": `ColumnFilter-module__font-s-18___Wk1j1`,
	"fontS20": `ColumnFilter-module__font-s-20___RGdiC`,
	"fontS22": `ColumnFilter-module__font-s-22___zBSMn`,
	"fontS28": `ColumnFilter-module__font-s-28___RmTcp`,
	"fontW400": `ColumnFilter-module__font-w-400___y1BaY`,
	"fontW500": `ColumnFilter-module__font-w-500___FCy3E`,
	"fontW600": `ColumnFilter-module__font-w-600___z7_0M`,
	"fontW700": `ColumnFilter-module__font-w-700___VK_lB`,
	"p5": `ColumnFilter-module__p-5___KCh2E`,
	"p12": `ColumnFilter-module__p-12___qifYn`,
	"p16": `ColumnFilter-module__p-16___gWmeZ`,
	"p30": `ColumnFilter-module__p-30___n2ymq`,
	"pB0": `ColumnFilter-module__p-b-0___tOteC`,
	"pB5": `ColumnFilter-module__p-b-5___drytx`,
	"pB10": `ColumnFilter-module__p-b-10___DH3SL`,
	"pB12": `ColumnFilter-module__p-b-12___RvZyd`,
	"pB16": `ColumnFilter-module__p-b-16___EtglN`,
	"pB18": `ColumnFilter-module__p-b-18___Pbcfv`,
	"pB20": `ColumnFilter-module__p-b-20___EoymV`,
	"pB25": `ColumnFilter-module__p-b-25___L8yWL`,
	"pB30": `ColumnFilter-module__p-b-30___MEF4a`,
	"pB50": `ColumnFilter-module__p-b-50___E5OWQ`,
	"pT0": `ColumnFilter-module__p-t-0___ymM7X`,
	"pT12": `ColumnFilter-module__p-t-12___DnkhM`,
	"pT16": `ColumnFilter-module__p-t-16___K3fvz`,
	"pT18": `ColumnFilter-module__p-t-18___q5coz`,
	"pT20": `ColumnFilter-module__p-t-20___TDxFP`,
	"pT30": `ColumnFilter-module__p-t-30___wrZJ3`,
	"pT40": `ColumnFilter-module__p-t-40___cfPVu`,
	"pT50": `ColumnFilter-module__p-t-50___CHIBv`,
	"pL20": `ColumnFilter-module__p-l-20___vOxQY`,
	"pL30": `ColumnFilter-module__p-l-30___atwTp`,
	"pL40": `ColumnFilter-module__p-l-40___HTb1J`,
	"pR16": `ColumnFilter-module__p-r-16___ncZ9f`,
	"pR20": `ColumnFilter-module__p-r-20___ZyWr5`,
	"pR30": `ColumnFilter-module__p-r-30___jICHk`,
	"pR50": `ColumnFilter-module__p-r-50___MsQop`,
	"pR60": `ColumnFilter-module__p-r-60___G5OKt`,
	"mB1": `ColumnFilter-module__m-b-1___gQ1pT`,
	"mB2": `ColumnFilter-module__m-b-2___bl41J`,
	"mB6": `ColumnFilter-module__m-b-6___cEY6d`,
	"mB8": `ColumnFilter-module__m-b-8___qln0H`,
	"mB10": `ColumnFilter-module__m-b-10____2XF_`,
	"mB14": `ColumnFilter-module__m-b-14___FXaIK`,
	"mB16": `ColumnFilter-module__m-b-16___Pess4`,
	"mB20": `ColumnFilter-module__m-b-20___czgKc`,
	"mB22": `ColumnFilter-module__m-b-22___gIPyn`,
	"mB24": `ColumnFilter-module__m-b-24___sjvSd`,
	"mB30": `ColumnFilter-module__m-b-30___I2io6`,
	"mB32": `ColumnFilter-module__m-b-32___XCd2n`,
	"mB40": `ColumnFilter-module__m-b-40___b3LLT`,
	"mT2": `ColumnFilter-module__m-t-2___p9c0d`,
	"mT3": `ColumnFilter-module__m-t-3___IlNKS`,
	"mT4": `ColumnFilter-module__m-t-4___VtP88`,
	"mT5": `ColumnFilter-module__m-t-5___D60Ib`,
	"mT8": `ColumnFilter-module__m-t-8___cfgK4`,
	"mT10": `ColumnFilter-module__m-t-10___opGnq`,
	"mT15": `ColumnFilter-module__m-t-15___nqK0C`,
	"mT16": `ColumnFilter-module__m-t-16___x_gqo`,
	"mT20": `ColumnFilter-module__m-t-20___nNqz_`,
	"mT22": `ColumnFilter-module__m-t-22___kf22G`,
	"mT30": `ColumnFilter-module__m-t-30___ZfoKt`,
	"mT32": `ColumnFilter-module__m-t-32___JLMmB`,
	"mLAuto": `ColumnFilter-module__m-l-auto___NZNO5`,
	"mL4": `ColumnFilter-module__m-l-4___yLbpn`,
	"mL5": `ColumnFilter-module__m-l-5___Emu_r`,
	"mL6": `ColumnFilter-module__m-l-6___dq2TD`,
	"mL8": `ColumnFilter-module__m-l-8___N3eqS`,
	"mL10": `ColumnFilter-module__m-l-10___c0_1h`,
	"mL16": `ColumnFilter-module__m-l-16___YTINc`,
	"mL20": `ColumnFilter-module__m-l-20___c9tLv`,
	"mL24": `ColumnFilter-module__m-l-24___tLQuG`,
	"mL30": `ColumnFilter-module__m-l-30___kUDpn`,
	"mL35": `ColumnFilter-module__m-l-35___YPGAV`,
	"mL40": `ColumnFilter-module__m-l-40___vdCy4`,
	"mR8": `ColumnFilter-module__m-r-8___b8yly`,
	"mR10": `ColumnFilter-module__m-r-10___RPoU9`,
	"mR16": `ColumnFilter-module__m-r-16___sYSWi`,
	"mR20": `ColumnFilter-module__m-r-20___PpcWn`,
	"mR24": `ColumnFilter-module__m-r-24___H38ae`,
	"mR30": `ColumnFilter-module__m-r-30___w60lq`,
	"mR40": `ColumnFilter-module__m-r-40___DLSch`,
	"borderR3": `ColumnFilter-module__border-r-3___sMeHE`,
	"borderR4": `ColumnFilter-module__border-r-4___OiuCo`,
	"borderR6": `ColumnFilter-module__border-r-6___H4CYO`,
	"borderR10": `ColumnFilter-module__border-r-10___qYwMG`,
	"borderR12": `ColumnFilter-module__border-r-12___YxjpI`,
	"borderR16": `ColumnFilter-module__border-r-16___Hy2P9`,
	"borderR50": `ColumnFilter-module__border-r-50___LF0Z8`,
	"primaryBorder": `ColumnFilter-module__primary-border___CNzil`,
	"primaryBorderB": `ColumnFilter-module__primary-border-b___VyK3x`,
	"primaryBorderT": `ColumnFilter-module__primary-border-t___Sn2br`,
	"primaryBorderL": `ColumnFilter-module__primary-border-l___vZyi4`,
	"primaryBorderR": `ColumnFilter-module__primary-border-r___TJdMb`,
	"secondaryBorder": `ColumnFilter-module__secondary-border___zJCYd`,
	"secondaryBorderB": `ColumnFilter-module__secondary-border-b___eb7Ro`,
	"secondaryBorderT": `ColumnFilter-module__secondary-border-t___LZsSS`,
	"secondaryBorderL": `ColumnFilter-module__secondary-border-l____fYtM`,
	"secondaryBorderR": `ColumnFilter-module__secondary-border-r___JNPBl`,
	"gap0": `ColumnFilter-module__gap-0___Fbkc9`,
	"gap2": `ColumnFilter-module__gap-2___rz0Vm`,
	"gap4": `ColumnFilter-module__gap-4___p5ZBw`,
	"gap5": `ColumnFilter-module__gap-5___eYi3N`,
	"gap6": `ColumnFilter-module__gap-6___cCI0l`,
	"gap8": `ColumnFilter-module__gap-8___fkHb9`,
	"gap10": `ColumnFilter-module__gap-10___PGIps`,
	"gap12": `ColumnFilter-module__gap-12___AV13S`,
	"gap14": `ColumnFilter-module__gap-14___t6rQs`,
	"gap16": `ColumnFilter-module__gap-16___nms6y`,
	"gap18": `ColumnFilter-module__gap-18___OFpfv`,
	"gap20": `ColumnFilter-module__gap-20___qVkdy`,
	"gap24": `ColumnFilter-module__gap-24___gluA4`,
	"gap26": `ColumnFilter-module__gap-26___N3hYZ`,
	"gap30": `ColumnFilter-module__gap-30___vwt0e`,
	"gap32": `ColumnFilter-module__gap-32____Wp5Y`,
	"gap40": `ColumnFilter-module__gap-40___LK9Ia`,
	"gap50": `ColumnFilter-module__gap-50___JfbvT`,
	"flex1": `ColumnFilter-module__flex-1____pRZ_`,
	"flexNone": `ColumnFilter-module__flex-none___Pb2Qm`,
	"flexColumn": `ColumnFilter-module__flex-column___Q0gTu`,
	"flexRow": `ColumnFilter-module__flex-row___alh8f`,
	"verticallyCentered": `ColumnFilter-module__vertically-centered___UB4_L`,
	"horizontallyCentered": `ColumnFilter-module__horizontally-centered___HgQaF`,
	"horizontallyEnd": `ColumnFilter-module__horizontally-end___r4WB1`,
	"verticallyStart": `ColumnFilter-module__vertically-start___lx6ko`,
	"spaceBetween": `ColumnFilter-module__space-between___n5K9v`,
	"flexWrap": `ColumnFilter-module__flex-wrap___X5Nt_`,
	"height100": `ColumnFilter-module__height-100___Alhip`,
	"width50": `ColumnFilter-module__width-50___CZcW8`,
	"width100": `ColumnFilter-module__width-100___WrOFO`,
	"cursorPointer": `ColumnFilter-module__cursor-pointer___tHrqd`,
	"cursorNotAllowed": `ColumnFilter-module__cursor-not-allowed___Vv0NT`,
	"absoluteCentered": `ColumnFilter-module__absolute-centered___qYO9n`,
	"absolute": `ColumnFilter-module__absolute___Ko8X0`,
	"relative": `ColumnFilter-module__relative___n3Lqf`,
	"fixed": `ColumnFilter-module__fixed___dlTuQ`,
	"visible": `ColumnFilter-module__visible___aoqle`,
	"invisible": `ColumnFilter-module__invisible___vXi3P`,
	"col90": `ColumnFilter-module__col-90___YSTq1`,
	"colAuto": `ColumnFilter-module__col-auto___wRbeX`,
	"medicalTabs": `ColumnFilter-module__medical-tabs___gCtzh`,
	"medicalTableNew": `ColumnFilter-module__medical-table-new___Ayx3R`,
	"noPagination": `ColumnFilter-module__no-pagination___bpo4x`,
	"medicalTableEmpty": `ColumnFilter-module__medical-table-empty___sCwuY`,
	"iconBtn": `ColumnFilter-module__icon-btn___IdsZN`,
	"searchIcon": `ColumnFilter-module__search-icon___UuSAe`,
	"disableSelect": `ColumnFilter-module__disable-select___D2nHj`,
	"breakWord": `ColumnFilter-module__break-word___d1it7`,
	"popupClearBtn": `ColumnFilter-module__popup-clear-btn___F7ko_`,
	"scrollMB20": `ColumnFilter-module__scroll-m-b-20___bob4l`,
	"container": `ColumnFilter-module__container___tMxR4`,
	"type": `ColumnFilter-module__type___Ci9Ub`,
	"filter": `ColumnFilter-module__filter___w0wu1`,
	"badge": `ColumnFilter-module__badge___TG5wl`,
	"option": `ColumnFilter-module__option___dCkg6`
};
module.exports = ___CSS_LOADER_EXPORT___;
